
export const CONTEXT_ACTION_TYPE = {

    login: '[Auth] Login',
    logout: '[Auth] Logout',

    addLog: '[Log] Add',
    clearLog: '[Log] Clear'

}